import { RefObject, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown, IconButton, VerticalMenu } from '../../../../../components'
import { useDropdownPosition } from '../../../../../components/common/Dropdown/useDropdownPosition'
import { useScrollPosition } from '../../../../../hooks/useScrollPosition/useScrollPosition'
import { useDropdownClickOutside } from '@/components/common/Dropdown/useDropdownClickOutside'

type ActionsDropdownProps = {
    onDownloadClick?: () => void
    onViewClick?: () => void
    containerRef?: RefObject<HTMLDivElement>
}

export const ActionsDropdown: React.FC<ActionsDropdownProps> = (props) => {
    const { onDownloadClick, onViewClick, containerRef } = props
    const { t } = useTranslation('translations')
    const [isOpen, setIsOpen] = useState(false)
    const { x, y } = useScrollPosition(containerRef)

    const { buttonRef, dropdownRef } = useDropdownClickOutside(() => {
        if (isOpen) {
            setIsOpen(false)
        }
    })

    const { horizontalAlign, verticalAlign } = useDropdownPosition(
        containerRef,
        dropdownRef,
        [isOpen, x, y]
    )

    return (
        <>
            <Dropdown
                name="payables-summary-actions-dropdown"
                dropdownRef={dropdownRef}
                buttonProps={{
                    name: 'payables-summary-actions-dropdown',
                    icon: 'more_horiz',
                    variant: 'ghostSecondary',
                    size: 'medium',
                    className: '[&:not(:hover):not(:focus)]:bg-[transparent]',
                    buttonRef,
                }}
                horizontalAlign={horizontalAlign}
                verticalAlign={verticalAlign}
                buttonComponent={IconButton}
                wrapperClassname="justify-end"
                dropdownClassname="py-2 min-w-tableActionsDropdownWidth"
                isOpen={isOpen}
                onClick={(event) => {
                    event.stopPropagation()
                    event.preventDefault()
                    setIsOpen((isOpen) => !isOpen)
                }}
            >
                <VerticalMenu
                    menuItems={[
                        {
                            id: 'view',
                            path: '/view',
                            label: t('common.view'),
                            render: ({ renderContents }) => {
                                return (
                                    <a
                                        className="cursor-pointer"
                                        onClick={onViewClick}
                                    >
                                        {renderContents()}
                                    </a>
                                )
                            },
                        },
                        {
                            id: 'download',
                            path: '',
                            label: t('common.download'),
                            render: ({ renderContents }) => {
                                return (
                                    <a
                                        className="cursor-pointer"
                                        onClick={(event) => {
                                            event.preventDefault()
                                            event.stopPropagation()
                                            setIsOpen(false)
                                            onDownloadClick?.()
                                        }}
                                    >
                                        {renderContents()}
                                    </a>
                                )
                            },
                        },
                    ]}
                    variant={'primary'}
                    hideLabel={false}
                    menuItemClassName={'w-auto whitespace-normal break-words'}
                />
            </Dropdown>
        </>
    )
}
